<template>
  <div class="col-sm-12 nopads p-2">
    <div>
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <form
        class="no-margin"
        @submit.prevent="onSubmit"
        @reset.prevent="onReset"
      >
        <div class="row">
          <div class="col-sm-6 px-2">
            <span class="span-title">
              {{ $t('ins_report.from_date') }}
            </span>
            <date-time-picker
              v-model:date="fromDate"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>

          <div class="col-sm-6 px-2">
            <span class="span-title">
              {{ $t('ins_report.to_date') }}
            </span>
            <date-time-picker
              v-model:date="toDate"
              class="routa-input"
              format="dd.MM.yyyy HH:mm"
              :enableTimePicker="true"
              :placeholder="$t('observations_videos.search_input_format')"
            />
          </div>
        </div>

        <div class="col-sm-12 d-flex justify-content-end">
            <button type="reset" class="btn btn-danger form-button">
                {{ $t('ins_report.clear') }}
            </button>
            <button type="submit" class="btn btn-primary form-button">
                {{ $t('ins_report.search') }}
            </button>
        </div>
      </form>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>


<script>
import {vehicleHelper} from '../../mixins/VehicleMixin'
import {restApi} from '../../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'VehicleTrips',
    components: { DateTimePicker },
    mixins: [vehicleHelper, restApi, timeUtils],
    props: {
        vehicleId: Number
    },
    data: function () {
        return {
            vehicle: null,
            fromDate: null,
            toDate: null,
            loading: false,
        }
    },


    mounted: function () {
        this.fromDate = this.getMonthStart()
    },

    methods: {

        onSubmit: function () {
            var params = {}

            if (this.fromDate) {
                params.from = this.fromDate
            }
            if (this.toDate) {
                params.to = this.toDate
            }

            if (this.vehicleId) {
                params.vehicle = this.vehicleId
            }
            params.trip_notes = 1
            this.$emit('search', params)
        },

        onReset: function () {
            this.toDate = null
            this.fromDate = this.getMonthStart()
        }

    }

}
</script>
